import { render, staticRenderFns } from "./cadastro-social-login-sem-email.vue?vue&type=template&id=3a7a649f&"
import script from "./cadastro-social-login-sem-email.vue?vue&type=script&lang=js&"
export * from "./cadastro-social-login-sem-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports